<template>
  <div>
    <b-row class="mb-2">
      <b-col>
        <!--        <b-button class="float-left" variant="primary" @click="allChange">{{ buttonLabel }}</b-button>-->
      </b-col>
    </b-row>
    <b-table
      id="table-transition-example"
      :items="data"
      :fields="fields"
      primary-key="optionId"
      :tbody-transition-props="transProps"
      show-empty
    >
      <template v-slot:head(selected)="row">
        <b-form-checkbox v-model="selectAll"></b-form-checkbox>
      </template>

      <template v-slot:cell(selected)="row">
        <b-form-checkbox v-model="row.item.selected"></b-form-checkbox>
      </template>

      <template v-slot:cell(saleStatus)="row">
        <v-select :options="optionStatus" v-model="row.item.saleStatus" :reduce="item =>item.value"
                  label="label" :searchable="false"></v-select>
        <!--        {{ row.item.saleStatus }}-->
      </template>

      <template v-slot:empty>
        <h4 style="text-align:center" class="mt-2">해당 옵션 목록이 없습니다.</h4>
      </template>
    </b-table>


    <b-row align-h="center">
      <!--      <b-button class="mr-1" @click="goBack()" variant="outline-primary">뒤로</b-button>-->
      <b-button @click="allChange()" variant="primary">{{ buttonLabel }}</b-button>
    </b-row>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  name: 'EditOptionList',
  components: {
    'v-select': vSelect,
  },
  props: ['data', 'buttonLabel'],
  data() {
    return {
      transProps: {
        name: 'list'
      },
      searchVal: '',
      optionStatus: [
        {label: '일시중지', value: 'false'},
        {label: '판매중', value: 'true'}
      ],
      selectAll: false,
      fields: [
        {key: 'selected', label: ''},
        {key: 'optionId', label: '번호'},
        {key: 'optionName', label: "옵션명"},
        {key: 'listPrice', label: "정상가"},
        {key: 'salePrice', label: "판매가"},
        {key: 'saleStatus', label: "판매상태"},
      ]
    }
  },
  mounted() {
  },

  watch: {
    selectAll(chk) {
      this.data.forEach(v => {
        v.selected = chk
      })
    },

    data(val) {
      console.log(val);
    }

  },

  methods: {

    //일시중지,판매중  일괄변경 버튼클릭
    allChange() {
      let checkFlag = false
      this.data.forEach(v => {
        if(v.selected) {
          checkFlag = true
        }
      })

      if(!checkFlag) {
        alert('변경할 옵션을 체크해주세요.')
        return false
      }

      //셀렉트박스 세팅
      var txt = ''
      this.data.forEach(v => {
        if(v.selected) {
          if(this.buttonLabel == "판매중") {
            v.saleStatus = 'true'
          } else {
            v.saleStatus = 'false'
          }
        }
      })


      // if(confirm("")){
      //   console.log(this.data);
      this.$emit('onSave', this.data, this.buttonLabel)
      // }


    },
    //저장버튼클릭
    onSave() {
      console.log(this.data);
      this.$emit('onSave', this.data, this.buttonLabel)
    },

    //뒤로버튼클릭
    goBack() {
      if(confirm("저장하지 않은 경우 입력된 정보가 적용되지 않습니다. 저장하시겠습니까?")) {
        //저장
        this.onSave()
      } else {
        this.$router.push(`../goods/goods-list`)
      }
    },

  } //method

}
</script>
<style>
.list-move {
  transition: transform 1s;
}

.list-item {
  display: inline-block;
  margin-right: 10px;
}

.list-enter-active, .list-leave-active {
  transition: all 1s;
}

.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */
{
  opacity: 0;
  transform: translateY(30px);
}

.table > tbody > tr > td {
  vertical-align: middle;
}
</style>
